import type { Role } from '../context/AuthContext';

/**
 * Rolwissel voor lokaal ontwikkelen. De browser mag de server vragen het verzoek
 * te behandelen als een verzonnen testaccount, zodat je kunt zien wat een
 * locatiebeheerder ziet en mag. De server beslist of dat mag; hier gebeurt niets
 * dat de rechten omzeilt.
 *
 * Buiten `npm start` op je eigen computer is dit altijd uitgeschakeld: bij een
 * gebouwde versie staat NODE_ENV op 'production'.
 */

export const DEV_MODE =
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_MODE !== 'false';

export const DEV_IDENTITY_HEADER = 'X-Dev-User-Email';

const STORAGE_KEY = 'dev_user_email';

export interface DevIdentity {
  email: string;
  name: string | null;
  role: Role;
  label: string;
  description: string;
  locations: { id: number; name: string | null; city: string | null }[];
}

export interface DevIdentitiesResponse {
  success: boolean;
  data: {
    current: string;
    default: string;
    identities: DevIdentity[];
  };
}

export const getDevIdentityEmail = (): string | null => {
  if (!DEV_MODE) return null;
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
};

export const setDevIdentityEmail = (email: string | null): void => {
  if (!DEV_MODE) return;
  try {
    if (email) {
      localStorage.setItem(STORAGE_KEY, email);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (error) {
    console.error('Kon de gekozen testidentiteit niet opslaan:', error);
  }
};
